export default {
  expiresSoon: 'Der Zugang zu "{appName}" wird nach dem {expiryDate} deaktiviert.',
  pinApp: 'App an die Navigationsleiste anheften',
  unpinApp: 'App von der Navigationsleiste lösen',
};
